import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import './TemplatesTypes.css';

const landingPages = [
    { id: 'landing-base', title: 'Base', description: 'A flexible and minimal starting point for any type of property listing or service offering. Easy to customize for your unique needs.', img: require('../../assets/imgs/previews/landing/base.jpg') },
    { id: 'landing-condo', title: 'Condominium', description: 'Tailored for urban condo listings, this layout highlights amenities, location perks, and compact living features in a clean, modern design.', img: require('../../assets/imgs/previews/landing/condo.jpg') },
    { id: 'landing-townhouse', title: 'Townhouse', description: 'Optimized for multi-level residential properties, this template focuses on spacious layouts, community details, and lifestyle advantages.', img: require('../../assets/imgs/previews/landing/townhouse.jpg') },
    { id: 'landing-multiplex', title: 'Multiplex', description: 'Ideal for showcasing income-generating properties, this layout emphasizes unit breakdowns, investment highlights, and rental potential.', img: require('../../assets/imgs/previews/landing/multiplex.jpg') },
];

const LandingPages = () => {
    const [searchQuery, setSearchQuery] = useState('');
    const [sortOrder, setSortOrder] = useState('az');

    let filteredTemplates = landingPages.filter(template =>
        template.title.toLowerCase().includes(searchQuery.toLowerCase()) ||
        template.description.toLowerCase().includes(searchQuery.toLowerCase())
    );

    if (sortOrder === 'az') {
        filteredTemplates = filteredTemplates.sort((a, b) => a.title.localeCompare(b.title));
    } else if (sortOrder === 'za') {
        filteredTemplates = filteredTemplates.sort((a, b) => b.title.localeCompare(a.title));
    }

    return (
        <>
            <Helmet>
                <title>Landing Page Templates | AptoWebsites</title>
                <meta name="description" content="High-converting landing page templates for listings, events, or lead generation. Fast, focused, and effective." />
                <meta name="keywords" content="landing page templates, real estate landing pages, lead generation, AptoWebsites" />
                <meta property="og:title" content="Landing Page Templates | AptoWebsites" />
                <meta property="og:description" content="High-converting landing page templates for listings, events, or lead generation. Fast, focused, and effective." />
                <meta property="og:type" content="website" />
                <meta property="og:url" content="https://aptowebsites.com/landing-pages" />
                <meta property="og:image" content="https://aptowebsites.com/og-image.jpg" />
                <link rel="canonical" href="https://aptowebsites.com/landing-pages" />
            </Helmet>
            <div className="templatebackground">
                <div className="template-header-bar professional">
                    <div className="template-header-titles">
                        <h1 className="template-header-title">Landing Page Templates</h1>
                    </div>
                    <div className="template-header-controls">
                        <div className="template-sort-group">
                            <label htmlFor="template-sort" className="template-sort-label">Sort:</label>
                            <select
                                id="template-sort"
                                className="template-sort-select"
                                value={sortOrder}
                                onChange={e => setSortOrder(e.target.value)}
                            >
                                <option value="az">A-Z</option>
                                <option value="za">Z-A</option>
                            </select>
                        </div>
                        <div className="template-search-group">
                            <svg className="search-icon" width="18" height="18" viewBox="0 0 20 20" fill="none">
                                <circle cx="9" cy="9" r="7" stroke="#0d47a1" strokeWidth="2"/>
                                <line x1="14.4142" y1="14" x2="18" y2="17.5858" stroke="#0d47a1" strokeWidth="2" strokeLinecap="round"/>
                            </svg>
                            <input
                                type="text"
                                placeholder="Search templates..."
                                value={searchQuery}
                                onChange={(e) => setSearchQuery(e.target.value)}
                                className="filter-input template-search-input"
                            />
                        </div>
                    </div>
                </div>
                <div className="template-section">
                    <div className="template-list">
                        {filteredTemplates.map(template => {
                            let mobileImgSrc;
                            try {
                                mobileImgSrc = require(`../../assets/imgs/previews/mobile/landing/${template.id.replace('landing-', '')}.jpg`);
                            } catch (e) {
                                mobileImgSrc = template.img;
                            }
                            return (
                                <Link to={`/${template.id}`} key={template.id} className="template-box">
                                    <div className="template-img-wrapper overlap">
                                        <img src={template.img} alt={template.title} className="template-img main-img" />
                                        <div className="phone-mockup-container overlap">
                                            <img
                                                src={require('../../assets/imgs/mockups/phone-mockup-transparent.png')}
                                                alt="Phone Mockup"
                                                className="phone-mockup-img"
                                            />
                                            <img
                                                src={mobileImgSrc}
                                                alt={`${template.title} mobile`}
                                                className="template-img phone-inside-img"
                                            />
                                        </div>
                                    </div>
                                    <div className="template-info">
                                        <h3>{template.title}</h3>
                                        <p>{template.description}</p>
                                    </div>
                                </Link>
                            );
                        })}
                    </div>
                </div>
            </div>
        </>
    );
};

export default LandingPages;
